import { render } from "./thPolicy.vue?vue&type=template&id=6285f9d3&scoped=true"
import script from "./thPolicy.vue?vue&type=script&lang=js"
export * from "./thPolicy.vue?vue&type=script&lang=js"

import "./thPolicy.vue?vue&type=style&index=0&id=6285f9d3&scoped=true&lang=scss"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6285f9d3"]])

export default __exports__